class MegaMenu {
  constructor() {
    const megaMenuButtons = document.querySelectorAll('.megaMenu__button');
    const megaMenuContent = document.querySelector('.megaMenu__menu');

    megaMenuButtons.forEach((button) => {
      button.addEventListener('click', () => {
        document.body.classList.toggle('no-scroll');
        megaMenuContent.classList.toggle('is-active');
        megaMenuButtons.forEach((button) => button.classList.toggle('is-active'));
      });
    });
  }
}

export default MegaMenu;